import React from 'react';
import FlatButton from 'material-ui/FlatButton';
import Dialog from 'material-ui/Dialog';
import RadioButtonGroup from 'material-ui/RadioButton/RadioButtonGroup';
import RadioButton from 'material-ui/RadioButton';
import RaisedButton from 'material-ui/RaisedButton';
import FileFileDownload from 'material-ui/svg-icons/file/file-download';
import ActionOpenInNew from 'material-ui/svg-icons/action/open-in-new';
import mdEntityService from "core/metamodel/mdEntityService";
import commonService from 'core/common/service/commonService';
import documentService from "core/document/documentService";
import gridService from "core/grid/gridService";
import Grid from 'core/grid/domain/grid';
import {MdCheckbox} from 'core/components/fields/fields';
import {getLovItem, lovParam} from "core/form/formUtils";
import {ObservableMap, action} from "mobx";
import MdEntity from "core/metamodel/mdEntity";
import {DocumentCountDto} from "core/document/documentDomain";
import {DialogProps, DialogAncestor} from "core/common/page/dialogAncestor";
import {observer} from "mobx-react";


interface DownloadDialogProps extends DialogProps {
  grid: Grid;
  entityName: string;
  documentLocation : string;
  bodyStyle?: any;
}




@observer
export default class DownloadDialog extends DialogAncestor<DownloadDialogProps, undefined, any> {


  @action open(resolve, reject, params: object) {
    let {entities, grid, entityName, documentLocation} = this.props;
    let gridParams = grid.createFullParams(params);
    console.log('DownloadDialog: Opening dialog params = %O ', gridParams);

    this.resolve = resolve;
    this.reject = reject;

    commonService.loading(true);


    Promise.all([mdEntityService.fetchEntities([{entity: 'DocumentType', lov: true}]), documentService.documentCount(entityName, documentLocation, gridParams)])
      .then(([entities, documentCountObjectDto]: [ObservableMap<MdEntity>, DocumentCountDto]) => {
        documentCountObjectDto.selectedFormat = documentCountObjectDto.formats[0].value as string;
        documentCountObjectDto.duplexPrinting = false;
        documentCountObjectDto.gridParams = gridParams;
        documentService.documentCountObject = documentCountObjectDto;
        commonService.loading(false);
        this.dialogOpen = true;
      })
      .catch(error => {
        this.reject(error);
      });

  }


  @action cancel = (evt) => {
    console.log('DownloadDialog#cancel evt = %O', evt);
    documentService.documentCountObject = null;
    this.dialogOpen = false;
    this.reject(null);
  };


  @action onChangeSelectedFormat = (evt, selectedFormat) => {
    console.log('onChangeSelectedFormat ', selectedFormat);
    documentService.documentCountObject.selectedFormat = selectedFormat;
  };

  @action onCheckDuplexPrinting = (evt, checked) => {
    console.log('onCheckDuplexPrinting ', checked);
    documentService.documentCountObject.duplexPrinting = checked;
  };



  render() {

    let {entities, grid, entityName, documentLocation, bodyStyle, children} = this.props;


    if (!this.dialogOpen) return null;


    const actions = [
      <FlatButton
        label="Close"
        secondary
        onClick={this.cancel}
      />];


    return (
      <Dialog
        title={this.titleWithProgress(`Found ${documentService.documentCountObject.documentCount} documents for requested ${documentService.documentCountObject.originalCount} entities`)}
        actions={actions}
        modal={true}
        open={this.dialogOpen}
        contentStyle={DownloadDialog_contentStyle}
        bodyStyle={ (bodyStyle) ? Object.assign({}, DownloadDialog_bodyStyle, bodyStyle) : DownloadDialog_bodyStyle }
      >

        {children}

        <div>
          <div style={{marginTop:10, marginLeft:20, height: 100}}>
              <h6 style={{fontSize:16}}>Download format</h6>
              <RadioButtonGroup name="selectedFormatRadio" valueSelected={documentService.documentCountObject.selectedFormat}
                                onChange={this.onChangeSelectedFormat}>
                {documentService.documentCountObject.formats.map( (format, index) => (<RadioButton key={index} value={format.value} label={format.label} style={{ display: 'inline-block', width: '25%' }}/>))}
              </RadioButtonGroup>
            { lovParam(getLovItem(documentService.documentCountObject.formats, documentService.documentCountObject.selectedFormat), 'concatable') ?
              <MdCheckbox name="duplexPrinting" checked={documentService.documentCountObject.duplexPrinting}
                        label="Duplex Printing" onCheck={this.onCheckDuplexPrinting}/>
                : null}
          </div>

          <div style={{marginTop:20, marginLeft:20, display:'flex'}}>
              <RaisedButton href={gridService.documentDownloadUrl(grid, documentLocation, documentService.documentCountObject, false)}
                            label="Download" icon={<FileFileDownload/>} primary style={{marginRight: 20}}/>
              <RaisedButton  href={gridService.documentDownloadUrl(grid, documentLocation, documentService.documentCountObject, true)}
                             target="_blank" label="Open" icon={<ActionOpenInNew/>} primary />
          </div>
        </div>


      </Dialog>
    );
  }

}

const DownloadDialog_bodyStyle = {overflow: 'visible', display:'flex', flexDirection: 'column', justifyContent: 'space-between'};
const DownloadDialog_contentStyle = {width: '80%', maxWidth: 800};



// WEBPACK FOOTER //
// ./src/core/document/component/downloadDialog.tsx